import React, { useState } from "react";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from ".././Helmet";
import RelatedLinks from "../RelatedLinks";
const TITLE = "Calculatrice Taille d'Échantillon";
const DESCRIPTION =
  "Calculatrice Taille d pour faire vos calculs mathematiques rapidement et sans erreur. Saisissez vos valeurs et obtenez un resultat immediat avec une methode simple a verifier.";
const KEYWORDS =
  "taille d, calculatrice taille d, calcul en ligne, mathematiques, pourcentage, formule, resultat rapide";
const OG_URL = "https://do-calculate.com/calculator/fr/sample-size";
function SampleSizeCalculator() {
  const [population, setPopulation] = useState("");
  const [confidence, setConfidence] = useState("95");
  const [margin, setMargin] = useState("5");
  const [result, setResult] = useState("");
  const [error, setError] = useState("");

  const handleCalculate = () => {
    try {
      const N = parseFloat(population);
      const z = parseFloat(confidence) === 95 ? 1.96 : parseFloat(confidence) === 99 ? 2.576 : 1.96;
      const e = parseFloat(margin) / 100;
      const p = 0.5;
      const sample = Math.ceil((z * z * p * (1 - p)) / (e * e));
      const finalSample = Math.ceil((sample * N) / (sample + N - 1));
      setResult(finalSample);
      setError("");
    } catch (err) {
      setError("Erreur de calcul");
    }
  };

  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div className="bg-success text-white text-center" style={{ height: "50px" }}>
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <hr />
                <div>
                  <div className="form-group">
                    <label>Taille de la population:</label>
                    <input
                      type="number"
                      value={population}
                      onChange={(e) => setPopulation(e.target.value)}
                      className="form-control"
                    />
                  </div>
                  <div className="form-group">
                    <label>Niveau de confiance (%):</label>
                    <select
                      value={confidence}
                      onChange={(e) => setConfidence(e.target.value)}
                      className="form-select"
                    >
                      <option value="95">95%</option>
                      <option value="99">99%</option>
                    </select>
                  </div>
                  <div className="form-group">
                    <label>Marge d'erreur (%):</label>
                    <input
                      type="number"
                      value={margin}
                      onChange={(e) => setMargin(e.target.value)}
                      className="form-control"
                    />
                  </div>
                  <button className="btn btn-success" onClick={handleCalculate}>
                    Calculer
                  </button>
                </div>
                <br />
                {error && (
                  <p className="p-3 mb-2 bg-warning text-dark">
                    Erreur: {error}
                  </p>
                )}
                {result && (
                  <p className="p-3 mb-2 bg-success text-white">
                    Taille d'échantillon: {result}
                  </p>
                )}
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
            <div className="row">
              <div className="col-sm-12 col-md-10">
                <div className="info-sections-container">
                  <div className="info-section">
                    <div className="info-section-header">
                      <h3 style={{ fontSize: "16px" }}>Qu'est-ce que la taille d'un échantillon ?</h3>
                    </div>
                    <div className="info-section-body">
                      <p>
                        La taille d'un échantillon est le nombre minimum d'individus
                        à inclure dans une étude pour que les résultats soient
                        représentatifs de la population cible.
                        Par exemple, pour étudier la consommation de café dans une ville
                        de 10 000 habitants, la taille d'échantillon doit être suffisante
                        pour refléter le comportement de toute la population.
                      </p>
                    </div>
                  </div>
                  <div className="info-section">
                    <div className="info-section-header">
                      <h3 style={{ fontSize: "16px" }}>Qu'est-ce que la marge d'erreur ?</h3>
                    </div>
                    <div className="info-section-body">
                      <p>
                        La marge d'erreur représente l'écart attendu entre les résultats
                        de l'échantillon et ceux de la population totale.
                        Par exemple, un résultat de 60% avec une marge de ±3% signifie
                        que la valeur réelle dans la population est entre 57% et 63%.
                        Plus la marge est faible, plus les résultats sont précis,
                        mais cela nécessite un échantillon plus grand.
                      </p>
                    </div>
                  </div>
                  <div className="info-section">
                    <div className="info-section-header">
                      <h3 style={{ fontSize: "16px" }}>Qu'est-ce que le niveau de confiance ?</h3>
                    </div>
                    <div className="info-section-body">
                      <p>
                        Le niveau de confiance exprime le degré de certitude que
                        les résultats de l'échantillon reflètent la réalité de la population.
                        Par exemple, un niveau de 95% signifie que si l'étude était
                        répétée 100 fois, les résultats seraient exacts 95 fois.
                        Le niveau de 95% est le plus courant ; certaines études requièrent 99%.
                      </p>
                    </div>
                  </div>
                  <div className="info-section">
                    <div className="info-section-header">
                      <h3 style={{ fontSize: "16px" }}>Comment la taille de la population influence-t-elle l'échantillon ?</h3>
                    </div>
                    <div className="info-section-body">
                      <p>
                        La taille de la population influence directement la taille
                        d'échantillon requise. Pour une petite population de 200 personnes,
                        vous aurez besoin d'un échantillon proportionnellement plus grand.
                        Mais au-delà d'une certaine taille de population (ex. un million),
                        augmenter l'échantillon améliore peu la précision des résultats.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>

    </div>
  );
}
export default SampleSizeCalculator;
